:host {
  display: block;
}

.item-active {
  &:hover {
    background: var(--navigation-heading-menu-hover-bg, linear-gradient(90deg, rgba(20, 20, 25, 0.6) 42.34%, rgba(28, 36, 50, 0.6) 86.33%));
  }
}
